// dependencies
import * as chrono from "chrono-node";
import { addYears, getMonth, getYear, isPast, parse } from "date-fns";

// utils
import get from "../../../../utils/GetNested";

/**
 * Will guess a month from 3 characters. example: aug -> august
 * @param {string} value
 */
const extrapolateMonth = (value: string) => {
	const months = {
		jan: "january",
		feb: "february",
		mar: "march",
		apr: "april",
		may: "may",
		jun: "june",
		jul: "july",
		aug: "august",
		sep: "september",
		oct: "october",
		nov: "november",
		dec: "december",
	};

	if (value.indexOf(" ") >= 0) {
		return value;
	}

	const normalizedValue = value.slice(0, 3).toLowerCase();
	const monthIndex = Object.keys(months).indexOf(normalizedValue);

	if (monthIndex >= 0) {
		return months[normalizedValue];
	}

	return value;
};

const guessDate = (value: string, forceDate = false) => {
	const today = new Date();
	const currentMonth = getMonth(today) + 1; // because january is 0 in date-fns

	const augmentedValue = extrapolateMonth(value);

	const results = chrono.parse(augmentedValue);
	const hasGuess = results.length >= 1;

	if (hasGuess) {
		const guess = results[0];
		const parsedComponents = get(guess, ["start"], {});

		// get known values
		let guessDay = get(parsedComponents, ["knownValues", "day"], null);
		let guessYear = get(parsedComponents, ["knownValues", "year"], null);
		let guessMonth = get(parsedComponents, ["knownValues", "month"], null);

		// if the year is not known, hold that info
		const isYearKnown = !!guessYear;

		if (!guessDay) {
			guessDay = get(guess, ["impliedValues", "day"], 1);
		}

		if (!guessMonth) {
			guessMonth = get(guess, ["impliedValues", "month"], 1);
		}

		if (!guessYear) {
			guessYear = get(guess, ["impliedValues", "year"], getYear(today));
		}

		const guessedDate = parse(`${guessYear}-${guessMonth}-${guessDay}`, "yyyy-M-d", new Date());

		// if the year was not known then we always want the guessed date to be
		// in the future unless the date is in the current month.
		if (!isYearKnown && isPast(guessedDate) && guessMonth !== currentMonth) {
			return addYears(guessedDate, 1);
		}

		return guessedDate;
	} else if (!hasGuess && forceDate) {
		return new Date();
	}

	return null;
};

export default guessDate;
